import { BillingPath, BillingRoutes } from 'entities/ExportRouters'
import { SuspendedPath } from 'pages/suspended/route/suspendedPath'
import { SettingsRoutes } from 'pages/settings/route/type'
import { type IConfigGlobalAccess } from 'app/shared/layouts/GlobalAccessLayout/config/config'

export const ruleSubscription: IConfigGlobalAccess = (entities, to, next) => {
  const { subscriptionStore, usersStore, organizationStore, authStore } = entities

  if (!authStore.isLoggedIn) {
    return next()
  }

  if (subscriptionStore.isActive || subscriptionStore.isTrial || subscriptionStore.isPastDue) {
    return next()
  }

  const isOwner = usersStore.user?.id === organizationStore.owner?.id
  const suspendedPath = `/${SuspendedPath.root}`
  // Canceled owners are redirected by BillingAccessLayout from the billing overview into the
  // add-subscription flow at /settings/upgrade, so it must be allowed too — otherwise this rule
  // bounces them straight back to /suspended.
  const allowedPaths = [
    suspendedPath,
    `/${BillingPath.root}`,
    `/${SettingsRoutes.root}/${BillingRoutes.upgrade}`,
  ]

  if (isOwner) {
    // Agency without subscription is handled by ruleAgency (redirects to /clients).
    if (subscriptionStore.isAgencyWithoutSubscription) {
      return next()
    }

    // Owners stay on /suspended but keep access to the whole billing subtree
    if (allowedPaths.some((path) => to.path === path || to.path.startsWith(`${path}/`))) {
      return next()
    }

    return next(suspendedPath)
  }

  // Agency members are handled by ruleAgency.
  if (subscriptionStore.isAgencyWithoutSubscription) {
    return next()
  }

  // Members are fully jailed to /suspended.
  if (to.path !== suspendedPath) {
    return next(suspendedPath)
  }

  return next()
}
